'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Panel = require('react-bootstrap/lib/Panel');

var _Panel2 = _interopRequireDefault(_Panel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Panel2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/BPanel.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/BPanel.js
 ** module chunks = 0
 **/